import React, { useEffect, useState } from 'react';
import '../styles/MarketMarquee.css';

const MarketMarquee = () => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    const fetchMarketData = async () => {
      try {
        // Fetch stocks
        const stockRes = await fetch(
          'https://stocks.algobook.info/api/v1/stocks?tickers=AAPL,NVDA,MSFT,GOOGL,AMZN,TSLA,META,AMD,INTC,CRM,ADBE,ORCL,CSCO,SNAP,UBER,LYFT,SHOP,ROKU,SQ,PLTR,NFLX,DIS,BA,KO,PEP'
        );
        const stockData = await stockRes.json();

        const formattedStocks = stockData.map(stock => {
          const price = typeof stock.lastPrice === 'number' ? stock.lastPrice : null;
          const change = stock.lastClose
            ? ((stock.lastPrice - stock.lastClose) / stock.lastClose * 100).toFixed(2)
            : '0.00';

          return {
            name: stock.name || stock.ticker,
            ticker: stock.ticker,
            price,
            percentChange: change,
            type: 'stock',
          };
        });

        // Fetch crypto
        const cryptoRes = await fetch(
          'https://api.coingecko.com/api/v3/coins/markets?vs_currency=usd&ids=bitcoin,ethereum,solana,dogecoin,cardano,polkadot'
        );
        const cryptoData = await cryptoRes.json();

        const formattedCryptos = cryptoData.map(coin => ({
          name: coin.name,
          ticker: coin.symbol.toUpperCase(),
          price: coin.current_price,
          percentChange: coin.price_change_percentage_24h?.toFixed(2) || '0.00',
          type: 'crypto',
        }));

        // Interleave crypto and stock data
        const maxLength = Math.max(formattedCryptos.length, formattedStocks.length);
        const interleaved = [];

        for (let i = 0; i < maxLength; i++) {
          if (formattedCryptos[i]) interleaved.push(formattedCryptos[i]);
          if (formattedStocks[i]) interleaved.push(formattedStocks[i]);
        }

        setItems(interleaved);
      } catch (err) {
        console.error('Error fetching market data:', err);
      }
    };

    fetchMarketData();
  }, []);

  const loopItems = [...items, ...items]; // duplicate for smooth scroll

  return (
    <div className="market-marquee-container">
      <div className="market-marquee">
        {loopItems.map((item, index) => (
          <div key={index} className="marquee-card">
            <div className="stock-name">
              {item.name}{' '}
              <span className={parseFloat(item.percentChange) >= 0 ? 'green' : 'red'}>
                ({item.percentChange}%)
              </span>
            </div>
            <div className="stock-price">
              {item.ticker} | {item.price !== null ? `$${item.price.toFixed(2)}` : 'N/A'}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MarketMarquee;
